import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Soft UI Context Provider
import { ArgonControllerProvider } from "context";

// react-perfect-scrollbar component
import PerfectScrollbar from "react-perfect-scrollbar";

// react-perfect-scrollbar styles
import "react-perfect-scrollbar/dist/css/styles.css";
import AppState from "context/appContext";
import { Provider } from "react-redux";
import { store } from "configs/store";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ArgonControllerProvider>
        <PerfectScrollbar>
          <AppState>
            <App />
          </AppState>
        </PerfectScrollbar>
      </ArgonControllerProvider>
    </Provider>
  </BrowserRouter>
);

